import { useMutation } from '@vue/apollo-composable';
import { useLocalizationStore } from '@/stores/localization';
import { GENERATE_ADYEN_ONBOARDING_LINK } from './onboarding/graphql';

export const generateOnboardingLink = () => {
  const { mutate } = useMutation(GENERATE_ADYEN_ONBOARDING_LINK);
  return new Promise<void>((resolve) => {
    mutate({ input: {} }).then((result: any) => {
      const url = result.data.generateAdyenOnboardingLink?.onboardingLink.url;

      if (url) {
        window.location.href = url;
      }

      resolve();
    });
  });
};

export const vimeoId = computed(() => {
  const { language } = useLocalizationStore();
  const ids = {
    nl: '924692632',
    de: '980575413',
    en: '1006913222',
  };
  return ids[language as keyof typeof ids];
});
